import { UserRoleEnum } from "src/types/role";
import type { User } from "src/types/user";

export const isAdminUser = (user: User): boolean => {
    if (user.role === UserRoleEnum.SUPERADMIN) {
        return true;
    }
    return false;
};
